import { render } from "./BiometricRegister.vue?vue&type=template&id=6d9073a0&scoped=true"
import script from "./BiometricRegister.vue?vue&type=script&lang=js"
export * from "./BiometricRegister.vue?vue&type=script&lang=js"

import "./BiometricRegister.vue?vue&type=style&index=0&id=6d9073a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9073a0"]])

export default __exports__